import React from "react";
import { connect } from "react-redux";
import "./index.css";
import "../index.css";
import IndicatorTimeline from "../IndicatorTimeline";

const TenthType = (props) => {
  const { data, index, activePoint, setActivePoint } = props;

  return data && <div className='tenth_type__container'>
    <IndicatorTimeline
      setActivePoint={setActivePoint}
      activePoint={activePoint}
      index={index}
      rotateClass
    />
    <div className='tenth_type__block block-header'>
      <div className="header_tenth_type">
        <h1>{data.year}</h1>
        <h3>{data.subtitle} </h3>
      </div>
    </div>
    <div className='tenth_type__block'>
      <div className="separator" />
      <div className="body_date_tenth_type">
        <div dangerouslySetInnerHTML={{ __html: data.body }} />
      </div>
    </div>
  </div>
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(TenthType);
